import { createRouter, createWebHistory } from "vue-router";

import "nprogress/nprogress.css";
import "@/app/layouts/types";
import modules from "@/app/router/modules";
import { authGuard, setRouterForGuards } from "@/app/router/utils/guards";
import { recordPageVisit, visitForNavigation } from "@/features/admin/pageVisits";
import { PERSISTENT_FILTER_PARAMS } from "@/shared/config/globalFilters.config";
import { progress } from "@/shared/lib/browser/progress";

const router = createRouter({
  history: createWebHistory(),
  routes: modules,
});

// Provide router instance to guards for Smart Redirects
setRouterForGuards(router);

router.beforeEach(async (to, from) => {
  progress.start();

  const title = (to.meta as { title?: string }).title;
  document.title = title ? `${title} | SO Insights` : "SO Insights";

  // Preserve filter query params when navigating between pages
  // Only if navigating to a different path (not just query change)
  if (to.path !== from.path && Object.keys(from.query).length > 0) {
    const persistedParams: Record<string, string> = {};

    for (const param of PERSISTENT_FILTER_PARAMS) {
      const value = from.query[param];
      if (value && !to.query[param]) {
        persistedParams[param] = Array.isArray(value) ? value[0] : value;
      }
    }

    // If we have params to persist and target doesn't have them
    if (Object.keys(persistedParams).length > 0) {
      return {
        ...to,
        query: {
          ...persistedParams,
          ...to.query,
        },
      };
    }
  }

  return authGuard(to, from);
});

router.afterEach((to, from, failure) => {
  progress.done();
  const visit = visitForNavigation(to, from, failure);
  if (visit) void recordPageVisit(visit);
});

router.onError(() => {
  progress.done();
});

export default router;
